import * as React from "react";
import { BlockText, Separator, Text } from "@nju/ui";

interface ICopy {
  numberVariant: "failed" | "success" | undefined;
}

export function SalesCopy({ numberVariant }: ICopy) {
  return (
    <>
      {numberVariant === "failed" && (
        <>
          <BlockText className="mt-8 only-mobile:mt-5">
            Z tym numerem klienta się nie udało – przejdź dalej i zapytaj, co
            chce klient zrobić w zamian.
          </BlockText>
          <BlockText>
            Na tym etapie nie ma możliwości usunięcia numeru. Wybierz:
          </BlockText>
        </>
      )}
      {numberVariant !== "failed" && (
        <Text className="mt-8 only-mobile:mt-5" display="block">
          Już wiemy, co klient chce zrobić z poprzednim numerem. Teraz przejdźmy
          do kolejnego.
        </Text>
      )}
      {numberVariant === "failed" && (
        <>
          <Separator size="s" tone="invisible" />
          <ul className="pl-3 list-disc marker:text-cerulean text-size-16">
            <li className="pl-2">
              <Text weight="bold">zmień numer,</Text> aby ponownie skonfigurować
              numer telefonu klienta (może przenieść numer od innego operatora
              lub zmienić ofertę z nju abonament, nju na kartę lub Orange),
            </li>
            <Separator size="xs" tone="invisible" />
            <li className="pl-2">
              <Text weight="bold">anuluj zamówienie</Text> i ponownie
              skonfiguruj ilość numerów klienta.
            </li>
          </ul>
        </>
      )}
    </>
  );
}
